import React, { useEffect, useState } from "react";
import { FunctionComponent } from "react";
import dayjs from "dayjs";
import { FullRetainerData } from ".";
import { euroDisplay } from "../../../../utils/formatters";
import { Link } from "react-router-dom";
import { Tag, Table, ColumnProps, Tooltip, TagColor } from "@getprorecrutement/getpro-design";

const PER_PAGE = 5;

interface Props {
  retainers?: FullRetainerData[];
}

export const DashboardRetainersList: FunctionComponent<Props> = (props) => {
  const { retainers } = props;
  const [page, setPage] = useState<number>(1);
  const [sortBy, setSortBy] = useState<{
    key: keyof FullRetainerData;
    sortDirection: undefined | "asc" | "desc";
  }>();

  useEffect(() => {
    setPage(1);
  }, [sortBy]);

  const columns: ColumnProps<FullRetainerData>[] = [
    {
      title: "Montant",
      dataIndex: "amount",
      key: "amount",

      width: 100,
      render: (value) => (
        <Tag
          value={value ? euroDisplay(value) : "À définir"}
          light
          bordered
          type={value ? (parseInt(value) > 0 ? TagColor.Success : TagColor.Error) : TagColor.Warning}
        />
      ),
    },
    {
      title: "Offre",
      dataIndex: "job_offer_name",
      key: "job_offer_name",
      width: 300,
      render: (value, record) =>
        value && (
          <Tooltip light title={value}>
            <Link to={`/jobs/${record.job_offer_id}`}>
              <div className="truncate">{value}</div>
            </Link>
          </Tooltip>
        ),
    },
    { title: "Propriétaire", dataIndex: "owner_name", key: "owner_name" },
    {
      title: "Entreprise",
      dataIndex: "customer_name",
      key: "customer_name",
      render: (value, record) =>
        value && (
          <Tooltip light title={value}>
            <Link to={`/billing/customers/${record.customer_id}`}>{value}</Link>
          </Tooltip>
        ),
    },
    {
      title: "Date",
      dataIndex: "paid_at",
      key: "paid_at",
      width: 130,
      sortable: true,
      render: (value) => <div>{dayjs(value).format("D MMM YYYY")}</div>,
    },
  ];

  const displayedRetainers = (
    (sortBy && sortBy.key === "paid_at"
      ? retainers?.sort((a, b) =>
          sortBy.sortDirection === "asc"
            ? dayjs(a.paid_at).diff(dayjs(b.paid_at))
            : dayjs(b.paid_at).diff(dayjs(a.paid_at))
        )
      : retainers) || []
  ).filter((_, i) => i >= (page - 1) * PER_PAGE && i < page * PER_PAGE);

  return (
    <Table
      size="small"
      dataSource={{ data: displayedRetainers, total: retainers?.length || 0 }}
      columns={columns}
      bordered
      light
      sortBy={sortBy}
      onSortDirectionChange={(key, direction) => {
        setSortBy({ key: key, sortDirection: direction });
      }}
      pagination={{ per_page: PER_PAGE, page, onChange: setPage }}
    />
  );
};

export default DashboardRetainersList;
